/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ColumnMetadataDto } from '../../models/column-metadata-dto';

export interface DatasourcesTablesTableMetadataIdColumnsGet$Json$Params {
  tableMetadataId: string;
}

export function datasourcesTablesTableMetadataIdColumnsGet$Json(http: HttpClient, rootUrl: string, params: DatasourcesTablesTableMetadataIdColumnsGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ColumnMetadataDto>>> {
  const rb = new RequestBuilder(rootUrl, datasourcesTablesTableMetadataIdColumnsGet$Json.PATH, 'get');
  if (params) {
    rb.path('tableMetadataId', params.tableMetadataId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ColumnMetadataDto>>;
    })
  );
}

datasourcesTablesTableMetadataIdColumnsGet$Json.PATH = '/datasources/tables/{tableMetadataId}/columns';
